
// Browser-wide errors (ResizeObserver, others)
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop completed')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return;
  }
});

import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router/router';
import './assets/global.css';
import { loadFonts } from './plugins/webfontloader';
import Vue3Toastify from 'vue3-toastify'; // Import vue3-toastify
import 'vue3-toastify/dist/index.css'; // Import the CSS for styling toasts


// Load fonts
loadFonts();

// Create Vue app
const app = createApp(App);

// Vue app internal errors (components exploding)
app.config.errorHandler = (err, vm, info) => {
  if (err.message && err.message.includes('ResizeObserver loop completed')) {
    // Suppress this harmless browser error silently
    return;
  }
  console.error('Vue error:', err?.message || err);
};

// Register vue3-toastify
app.use(Vue3Toastify, {
  autoClose: 5000, // Errors show for 5 seconds
  position: 'top-center' // Position at the top-center of the screen
});

// Register other plugins
app.use(vuetify);
app.use(router);

// Mount the app
app.mount('#app');
